import { Component, Inject, Injector, Input } from '@angular/core'; // Usunięto ReflectiveInjector
import { CHIPS_VIEW, ListService } from '../../services/list.service';

@Component({
  selector: 'app-list-chips-active-filters',
  templateUrl: './list-chips-active-filters.component.html',
  styleUrls: ['./list-chips-active-filters.component.scss']
})
export class ListChipsActiveFiltersComponent {
  @Input() component: any;

  myInjector: Injector;

  constructor(
    public service: ListService,
    @Inject(Injector) private parentInjector: Injector
  ) {
    this.myInjector = Injector.create({
      providers: [{ provide: CHIPS_VIEW, useValue: true }],
      parent: this.parentInjector
    });
  }
}
